

export default   function ValidateEmail(value) {
    
    const validRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (value.match(validRegex)) {
      return true;
    } else {
      return false;
    }
  }

